// Admin API client with bearer token handling.
import axios from "axios";
import { API } from "./api";

const TOKEN_KEY = "veloura_admin_token";

export const adminApi = axios.create({
    baseURL: `${API}/admin`,
    headers: { "Content-Type": "application/json" },
});

adminApi.interceptors.request.use((config) => {
    const tok = localStorage.getItem(TOKEN_KEY);
    if (tok) config.headers.Authorization = `Bearer ${tok}`;
    return config;
});

export function setAdminToken(token) {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
}

export function getAdminToken() {
    return localStorage.getItem(TOKEN_KEY);
}
